module.exports = __webpack_public_path__ + "img/5_1.77859494.jpg";